module.exports = __webpack_public_path__ + "img/ico_ll1.5c410ee3.png";